// import {
//   UseFormRegister,
//   RegisterOptions,
//   UseFormClearErrors,
//   UseFormSetValue,
// } from "react-hook-form";
// import { useState, useEffect, useRef, useCallback } from "react";
// import { IconChevronDown, IconX } from "@tabler/icons-react";
// import { FaSpinner } from "react-icons/fa";
// import FormErrorMessage from "./common/FormErrorMessage";

// type SelectOption = {
//   id?: string | number;
//   value: string | number;
//   text: string;
//   img?: string;
// };

// type Props = {
//   name: string;
//   label?: string;
//   placeholder?: string;
//   selectOptions: SelectOption[];
//   register?: UseFormRegister<any>;
//   validation?: RegisterOptions;
//   error?: any;
//   className?: string;
//   labelClass?: string;
//   disabled?: boolean;
//   removeDiv?: boolean;
//   value?: string | any;
//   setValue?: (val: string | any) => void;
//   onChange?: (val: string | any) => void;
//   clearErrors?: UseFormClearErrors<any>;
//   formSetValue?: UseFormSetValue<any>;
//   onSearch?: (query: string) => void; // 🔹 API search trigger
//   isPending?: boolean; // 🔹 show spinner while loading
//   allowCustom?: boolean; // 🔹 allow custom text input
//   displayValue?: string; // 🔹 explicit text to display instead of looking up value
//   inputClassName?: string; // 🔹 custom class for the select input wrapper
// };

// export default function SelectInput({
//   name,
//   label,
//   placeholder = "Select",
//   selectOptions,
//   register,
//   validation,
//   error,
//   className = "",
//   labelClass = "",
//   disabled = false,
//   removeDiv = false,
//   value,
//   setValue,
//   onChange,
//   clearErrors,
//   formSetValue,
//   onSearch,
//   isPending,
//   allowCustom,
//   displayValue,
//   inputClassName,
// }: Props) {
//   const [selectOpen, setSelectOpen] = useState(false);
//   const [searchText, setSearchText] = useState("");
//   const [isFocused, setIsFocused] = useState(false);
//   const [openUpward, setOpenUpward] = useState(false);
//   const dropdownRef = useRef<HTMLDivElement>(null);
//   const inputRef = useRef<HTMLInputElement>(null);

//   // selected option text
//   const selectedText =
//     displayValue ??
//     (selectOptions?.find((opt) => String(opt?.value) === String(value))?.text ||
//       (allowCustom && typeof value === "string" ? value : ""));

//   // Whether a real value is selected (for showing clear button)
//   const hasValue = !!(value && value !== "");

//   // filter locally — when focused with no typed text, show all options
//   const filteredOptions = searchText
//     ? selectOptions?.filter((opt) =>
//         opt?.text?.toLowerCase().includes(searchText?.toLowerCase()),
//       )
//     : selectOptions;

//   const handleSelect = (val: string | number) => {
//     if (setValue) setValue(val);
//     if (onChange) onChange(val);
//     if (clearErrors) clearErrors(name);
//     if (formSetValue) formSetValue(name, val);
//     setSelectOpen(false);
//     setSearchText(""); // reset search after select
//     setIsFocused(false);
//   };

//   const handleClear = useCallback(
//     (e: React.MouseEvent) => {
//       e.stopPropagation();
//       if (setValue) setValue("");
//       if (onChange) onChange("");
//       if (clearErrors) clearErrors(name);
//       if (formSetValue) formSetValue(name, "");
//       setSearchText("");
//       setSelectOpen(false);
//       setIsFocused(false);
//     },
//     [setValue, onChange, clearErrors, formSetValue, name],
//   );

//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (
//         dropdownRef.current &&
//         !dropdownRef.current.contains(event.target as Node)
//       ) {
//         setSelectOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleDropdownToggle = () => {
//     if (disabled) return;

//     if (dropdownRef.current) {
//       const rect = dropdownRef.current.getBoundingClientRect();
//       const spaceBelow = window.innerHeight - rect.bottom;
//       const spaceAbove = rect.top;
//       setOpenUpward(spaceBelow < 250 && spaceAbove > 250);
//     }

//     setSelectOpen((prev) => !prev);
//   };

//   // 🔹 handle search input
//   const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const query = e.target.value;
//     setSearchText(query);
//     if (!selectOpen) setSelectOpen(true);

//     if (onSearch && query.trim().length >= 3) {
//       onSearch(query.trim());
//     }
//   };

//   // When the input gains focus: clear searchText so user types into fresh search
//   // (fixes "first letter acts as backspace" — previously selectedText was shown
//   // inside the input value, so the first keystroke would replace all visible text)
//   const handleInputFocus = () => {
//     setIsFocused(true);
//     setSearchText(""); // always start fresh when focusing
//     setSelectOpen(true);
//   };

//   const handleInputBlur = () => {
//     // Delay so click on dropdown item can fire first
//     setTimeout(() => setIsFocused(false), 150);
//   };

//   const labelNode = label && (
//     <label
//       htmlFor={name}
//       className={`text-[#1E293B] text-xs ${labelClass} whitespace-nowrap`}
//     >
//       {label}
//       {validation?.required && <span className="text-red-600 ml-1">*</span>}
//     </label>
//   );

//   const dropdown = (
//     <div
//       className={`absolute z-30 left-0 w-full rounded-xl bg-white ${
//         searchText?.length >= 3 && "border border-gray-200"
//       } shadow-lg max-h-60 overflow-y-auto ${
//         openUpward ? "bottom-full mb-1" : "top-full mt-1"
//       }`}
//     >
//       <ul>
//         {filteredOptions?.map((opt, i) => (
//           <li
//             key={opt.id ?? i}
//             className={`px-4 py-2 text-xs hover:bg-blue-100 cursor-pointer flex items-center gap-2 ${
//               String(opt.value) === String(value)
//                 ? "bg-blue-50 font-medium"
//                 : ""
//             }`}
//             onClick={() => handleSelect(opt.value)}
//           >
//             {opt?.img && (
//               <img src={opt.img} className="size-8 rounded-md object-cover" />
//             )}

//             {opt.text}
//           </li>
//         ))}

//         {/* Show "No results" only when user typed */}
//         {searchText && filteredOptions?.length === 0 && !allowCustom && (
//           <li className="px-4 py-2 text-xs text-gray-400">No results found</li>
//         )}

//         {/* Custom text entry */}
//         {searchText &&
//           allowCustom &&
//           !filteredOptions?.some(
//             (o) => o.text.toLowerCase() === searchText.toLowerCase(),
//           ) && (
//             <li
//               className="px-4 py-2 text-xs hover:bg-blue-100 cursor-pointer flex items-center gap-2 text-blue-600"
//               onClick={() => handleSelect(searchText)}
//             >
//               Use "{searchText}"
//             </li>
//           )}
//       </ul>
//     </div>
//   );

//   const selectField = (
//     <div ref={dropdownRef} className="relative w-full">
//       <div
//         className={`flex items-center justify-between px-4 py-2 text-xs rounded-xl border ${
//           error ? "border-red-500" : "border-gray-200"
//         }  ${disabled ? "opacity-70 bg-gray-100" : "cursor-pointer bg-white"}`}
//         onClick={handleDropdownToggle}
//       >
//         {/* 🔹 Inline search input — value shows searchText when typing, or selectedText when idle */}
//         <input
//           ref={inputRef}
//           type="text"
//           className="flex-1 bg-transparent text-xs outline-none placeholder:text-gray-400 min-w-0"
//           placeholder={placeholder}
//           value={isFocused ? searchText : selectedText}
//           onChange={handleSearchChange}
//           onFocus={handleInputFocus}
//           onBlur={handleInputBlur}
//           autoComplete="new-password"
//           onClick={(e) => e.stopPropagation()}
//         />

//         {/* 🔹 Spinner when searching */}
//         {searchText?.length >= 3 && isPending && (
//           <FaSpinner
//             className="animate-spin text-gray-500 ml-2 flex-shrink-0"
//             size={16}
//           />
//         )}

//         {/* ✕ Clear button — only shown when a value is selected and not loading */}
//         {hasValue && !isPending && (
//           <button
//             type="button"
//             onMouseDown={handleClear}
//             className="flex-shrink-0 ml-1 text-gray-400 hover:text-red-500 transition-colors"
//             tabIndex={-1}
//             aria-label="Clear selection"
//           >
//             <IconX size={14} stroke={2.5} />
//           </button>
//         )}

//         <IconChevronDown
//           size={18}
//           stroke={2.2}
//           className={`text-gray-500 transition-transform flex-shrink-0 ml-1 ${
//             selectOpen ? "rotate-180" : ""
//           }`}
//         />
//       </div>

//       {selectOpen && dropdown}

//       {register && !formSetValue && (
//         <input
//           autoComplete="off"
//           type="hidden"
//           {...register(name, validation)}
//           value={value ?? ""}
//         />
//       )}
//     </div>
//   );

//   return (
//     <div className={`space-y-1 relative ${className}`}>
//       {labelNode}
//       <div className="w-full">
//         {removeDiv ? (
//           selectField
//         ) : (
//           <div className="relative">{selectField}</div>
//         )}
//         <FormErrorMessage error={error} />
//       </div>
//     </div>
//   );
// }



import {
  UseFormRegister,
  RegisterOptions,
  UseFormClearErrors,
  UseFormSetValue,
} from "react-hook-form";
import { useState, useEffect, useRef, useCallback } from "react";
import { createPortal } from "react-dom";
import { IconChevronDown, IconX } from "@tabler/icons-react";
import { FaSpinner } from "react-icons/fa";
import FormErrorMessage from "./common/FormErrorMessage";
import { useLanguage } from "../context/LanguageContext";

type SelectOption = {
  id?: string | number;
  value: string | number;
  text: string;
  img?: string;
};

type Props = {
  name: string;
  label?: string;
  placeholder?: string;
  selectOptions: SelectOption[];
  register?: UseFormRegister<any>;
  validation?: RegisterOptions;
  error?: any;
  className?: string;
  labelClass?: string;
  disabled?: boolean;
  removeDiv?: boolean;
  value?: string | any;
  setValue?: (val: string | any) => void;
  onChange?: (val: string | any) => void;
  clearErrors?: UseFormClearErrors<any>;
  formSetValue?: UseFormSetValue<any>;
  onSearch?: (query: string) => void;
  isPending?: boolean;
  allowCustom?: boolean;
  displayValue?: string;
  inputClassName?: string;
  usePortal?: boolean; // new prop, default true
  roundedFull?: boolean;
};

export default function SelectInput({
  name,
  label,
  placeholder = "Select",
  selectOptions,
  register,
  validation,
  error,
  className = "",
  labelClass = "",
  disabled = false,
  removeDiv = false,
  value,
  setValue,
  onChange,
  clearErrors,
  formSetValue,
  onSearch,
  isPending,
  allowCustom,
  displayValue,
  inputClassName,
  usePortal = true,
  roundedFull = false,
}: Props) {
  const { t } = useLanguage();
  const [selectOpen, setSelectOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [openUpward, setOpenUpward] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState<{
    top: number;
    left: number;
    width: number;
  } | null>(null);

  const dropdownRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  // selected option text
  const selectedText =
    displayValue ??
    (selectOptions?.find((opt) => String(opt?.value) === String(value))?.text ||
      (allowCustom && typeof value === "string" ? value : ""));

  const hasValue = !!(value && value !== "");

  const filteredOptions = searchText
    ? selectOptions?.filter((opt) =>
        opt?.text?.toLowerCase().includes(searchText?.toLowerCase()),
      )
    : selectOptions;

  const handleSelect = (val: string | number) => {
    if (setValue) setValue(val);
    if (onChange) onChange(val);
    if (clearErrors) clearErrors(name);
    if (formSetValue) formSetValue(name, val);
    setSelectOpen(false);
    setSearchText("");
    setIsFocused(false);
  };

  const handleClear = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      if (setValue) setValue("");
      if (onChange) onChange("");
      if (clearErrors) clearErrors(name);
      if (formSetValue) formSetValue(name, "");
      setSearchText("");
      setSelectOpen(false);
      setIsFocused(false);
    },
    [setValue, onChange, clearErrors, formSetValue, name],
  );

  // Compute dropdown position
  const updateDropdownPosition = useCallback(() => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;
    const shouldOpenUpward = spaceBelow < 250 && spaceAbove > 250;
    setOpenUpward(shouldOpenUpward);

    setDropdownPosition({
      top: shouldOpenUpward
        ? rect.top + window.scrollY - 10
        : rect.bottom + window.scrollY + 10,
      left: rect.left + window.scrollX,
      width: rect.width,
    });
  }, []);

  const handleDropdownToggle = () => {
    if (disabled) return;
    if (!selectOpen) {
      updateDropdownPosition();
    }
    setSelectOpen((prev) => !prev);
  };

  // Update position on scroll/resize when open
  useEffect(() => {
    if (!selectOpen) return;
    const handleUpdate = () => updateDropdownPosition();
    window.addEventListener("scroll", handleUpdate, true);
    window.addEventListener("resize", handleUpdate);
    return () => {
      window.removeEventListener("scroll", handleUpdate, true);
      window.removeEventListener("resize", handleUpdate);
    };
  }, [selectOpen, updateDropdownPosition]);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setSelectOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value;
    setSearchText(query);
    if (!selectOpen) setSelectOpen(true);

    if (onSearch && query.trim().length >= 3) {
      onSearch(query.trim());
    }
  };

  const handleInputFocus = () => {
    setIsFocused(true);
    setSearchText("");
    setSelectOpen(true);
  };

  const handleInputBlur = () => {
    setTimeout(() => setIsFocused(false), 150);
  };

  // Dropdown content (shared between portal and inline)
  const dropdownContent = (
    <div
      className={`rounded-xl bg-white border border-gray-200 shadow-lg max-h-60 overflow-y-auto w-full`}
    >
      <ul>
        {filteredOptions?.map((opt, i) => (
          <li
            key={opt.id ?? i}
            className={`px-4 py-2 text-xs hover:bg-blue-100 cursor-pointer flex items-center gap-2 ${
              String(opt.value) === String(value)
                ? "bg-blue-50 font-medium"
                : ""
            }`}
            onClick={() => handleSelect(opt.value)}
          >
            {opt?.img && (
              <img src={opt.img} className="size-8 rounded-md object-cover" />
            )}
            {t(opt.text)}
          </li>
        ))}
        {searchText && filteredOptions?.length === 0 && !allowCustom && (
          <li className="px-4 py-2 text-xs text-gray-400">{t("No results found")}</li>
        )}
        {searchText &&
          allowCustom &&
          !filteredOptions?.some(
            (o) => o.text.toLowerCase() === searchText.toLowerCase(),
          ) && (
            <li
              className="px-4 py-2 text-xs hover:bg-blue-100 cursor-pointer flex items-center gap-2 text-blue-600"
              onClick={() => handleSelect(searchText)}
            >
              {t("Use")} "{searchText}"
            </li>
          )}
      </ul>
    </div>
  );

  const labelNode = label && (
    <label
      htmlFor={name}
      className={`block text-xs text-[#1E293B] ${labelClass} whitespace-nowrap`}
    >
      {t(label)}
      {validation?.required && <span className="text-red-500 ml-1">*</span>}
    </label>
  );

  const selectField = (
    <div ref={containerRef} className="relative w-full">
      <div
        className={`flex items-center justify-between px-4 ${
          roundedFull ? "rounded-full py-[6px]" : (inputClassName?.includes("h-") ? "rounded-xl" : "rounded-xl py-2")
        } text-xs border transition-all ${
          error ? "border-red-500" : (selectOpen || isFocused) ? "border-[#FBD037]" : "border-gray-200"
        }  ${disabled ? "opacity-70 bg-gray-100 cursor-not-allowed" : "cursor-pointer bg-white"} ${inputClassName || ""}`}
        onClick={handleDropdownToggle}
      >
        <input
          ref={inputRef}
          type="text"
          className="flex-1 bg-transparent text-xs outline-none placeholder:text-gray-400 min-w-0 disabled:cursor-not-allowed"
          placeholder={t(placeholder)}
          value={isFocused ? searchText : t(selectedText)}
          onChange={handleSearchChange}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          autoComplete="new-password"
          onClick={(e) => e.stopPropagation()}
          disabled={disabled}
        />

        {searchText?.length >= 3 && isPending && (
          <FaSpinner
            className="animate-spin text-gray-500 ml-2 flex-shrink-0"
            size={16}
          />
        )}

        {hasValue && !isPending && !disabled && (
          <button
            type="button"
            onMouseDown={handleClear}
            className="flex-shrink-0 ml-1 text-gray-400 hover:text-red-500 transition-colors"
            tabIndex={-1}
            aria-label="Clear selection"
          >
            <IconX size={14} stroke={2.5} />
          </button>
        )}

        <IconChevronDown
          size={18}
          stroke={2.2}
          className={`text-gray-500 transition-transform flex-shrink-0 ml-1 ${
            selectOpen ? "rotate-180" : ""
          }`}
        />
      </div>

      {selectOpen &&
        (usePortal && dropdownPosition ? (
          createPortal(
            <div
              ref={dropdownRef}
              style={{
                position: "fixed",
                top: dropdownPosition.top,
                left: dropdownPosition.left,
                width: dropdownPosition.width,
                zIndex: 9999,
              }}
            >
              {dropdownContent}
            </div>,
            document.body
          )
        ) : (
          <div ref={dropdownRef} className="absolute z-30 w-full">
            {dropdownContent}
          </div>
        ))}

      {register && !formSetValue && (
        <input
          autoComplete="off"
          type="hidden"
          {...register(name, validation)}
          value={value ?? ""}
        />
      )}
    </div>
  );

  return (
    <div className={`space-y-1 relative ${className}`}>
      {labelNode}
      <div className="w-full flex-1 min-w-0">
        {removeDiv ? (
          selectField
        ) : (
          <div className="relative">{selectField}</div>
        )}
        <FormErrorMessage error={error} />
      </div>
    </div>
  );
}